import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { StatusPageActions } from './status-page.actions';
import { StatusPageSelectors } from './status-page.selectors';

@Injectable({ providedIn: 'root' })
export class StatusPageStore {
  state$ = this.store.select(StatusPageSelectors.getState());
  status$ = this.store.select(StatusPageSelectors.getStatus());
  scheduledMaintenance$ = this.store.select(StatusPageSelectors.getScheduledMaintenance());
  shouldMaintenanceBannerBeDisplayed$ = this.store.select(
    StatusPageSelectors.shouldMaintenanceBannerBeDisplayed()
  );

  constructor(private store: Store) {}

  getStatus(): void {
    this.store.dispatch(StatusPageActions.getStatus());
  }

  getStatusWithoutTimer(): void {
    this.store.dispatch(StatusPageActions.getStatusWithoutTimer());
  }

  getMaintenances(): void {
    this.store.dispatch(StatusPageActions.getMaintenances());
  }
}
